import * as v from 'valibot'

/**
 * An ISO-8601 wire string, validated and converted to a `Date`.
 *
 * @remarks
 *   `isoTimestamp` requires a timezone designator, which is what
 *   `Date.prototype.toISOString` emits. A date-only or locale string is
 *   rejected rather than silently coerced by `new Date`.
 */
export const IsoDateSchema = v.pipe(
  v.string(),
  v.isoTimestamp('Invalid ISO timestamp'),
  v.transform((value) => new Date(value)),
)
